import SVG from "shared/SVG";
import "./Footer.scss";
import { ROUTE_ENUM, SVG_ENUM } from "enums";
import { useNavigate } from "react-router";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <div className="layout footer__content">
        <span
          className="footer__logo"
          onClick={() => navigate(ROUTE_ENUM.HOME)}
        >
          <SVG type={SVG_ENUM.LOGO} />
        </span>
        <div className="footer__right">
          <div className="footer__columns">
            <div className="footer__links">
              <p onClick={() => navigate(ROUTE_ENUM.TERMS_OF_SERVICE)}>
                Regulamin
              </p>
              <p onClick={() => navigate(ROUTE_ENUM.PRIVACY_POLICY)}>
                Polityka prywatności
              </p>
            </div>
            <div className="footer__address">
              <div>
                <p>al. 29 Listopada 39E/U3</p>
                <p>31-425 Kraków</p>
              </div>
              <div>
                <p>+48 123 450 744</p>
                <p>
                  <a href="mailto:biuro@reliance.pro">biuro@reliance.pro</a>
                </p>
              </div>
            </div>
          </div>
          <div className="footer__law">
            <p>© 2024 Reliance Holding. Wszelkie prawa zastrzeżone</p>
            <p>
              Website by{" "}
              <a target="_blank" href="https://korg.software" rel="noreferrer">
                korg.software
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
